// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3EpWz","content":"styles_content__3j9Rv"};